import React from "react";
import { IconBase, IconComponent } from "../../core/Icons";

/** Outline tablet — matches Staff/Timesheet white + #8BC8FF accent on blue sidebar. */
export const DeviceIcon: React.FC<IconComponent> = (props) => {
  return (
    <IconBase {...props}>
      <rect
        x="10"
        y="4"
        width="18"
        height="30"
        rx="3"
        stroke="white"
        strokeWidth="2"
        fill="none"
      />
      <rect x="13" y="8" width="12" height="18" rx="1.5" fill="#8BC8FF" opacity="0.35" />
      <circle cx="19" cy="30" r="1.8" fill="white" />
    </IconBase>
  );
};
